export default "__VITE_ASSET__Bdwu0Xwf__"